export const colors = {
  background: '#0A0A0A',
  surface: '#171717',
  card: '#1A1A1A',
  border: '#333333',
  text: '#FFFFFF',
  textMuted: '#B0B0B0',
  primary: '#00C853',
  secondary: '#2962FF',
  accent: '#FFD600',
  danger: '#FF1744',
  warning: '#FFD600',

  missing: '#4A4A4A',
  missingBorder: '#666666',
  owned: '#00C853',
  ownedBorder: '#00C853',
  repeated: '#2962FF',
  repeatedBorder: '#2962FF',
  special: '#FF1744',
  specialBorder: '#FF1744',
} as const;

export const countryColors: Record<string, string> = {
  MEX: '#00C853',
  USA: '#FF1744',
  CAN: '#FF1744',
  ARG: '#40C4FF',
  BRA: '#FFD600',
  COL: '#FFD600',
  ECU: '#FFD600',
  PER: '#FF1744',
  URU: '#40C4FF',
  CHI: '#40C4FF',
  PAR: '#00C853',
  VEN: '#40C4FF',
  BOL: '#FFD600',
  GUA: '#00C853',
  CRC: '#2962FF',
  HON: '#2962FF',
  JAM: '#FFD600',
  PAN: '#00C853',
  TRI: '#FF1744',
  ESA: '#2962FF',
  CAN16: '#FF1744',
  USA16: '#FF1744',
  MEX16: '#00C853',
  RSA: '#00C853',
  SEN: '#FFD600',
  MAR: '#FF1744',
  NGA: '#00C853',
  CMR: '#FF1744',
  GHA: '#FFD600',
  CIV: '#FFD600',
  ALG: '#FF1744',
  TUN: '#FF1744',
  EGY: '#FFD600',
  BUR: '#FFD600',
  UGA: '#FFD600',
  COD: '#2962FF',
  ZAM: '#FFD600',
  KOR: '#2962FF',
  JPN: '#FF1744',
  AUS: '#00C853',
  IRN: '#00C853',
  QAT: '#FF1744',
  KSA: '#00C853',
  UAE: '#FF1744',
  IRQ: '#00C853',
  IDN: '#FF1744',
  CHN: '#FF1744',
} as const;

export const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
} as const;

export const radii = {
  sm: 8,
  md: 14,
  lg: 22,
} as const;